module.exports = __webpack_public_path__ + "img/curacao.d7f61229.svg";